import React from 'react'
import PropTypes from 'prop-types'

import Container from '@hixme-ui/container'
import Text from '@hixme-ui/text'

import Tag from '../Tag'

const TagsEditor = ({ Id, selectAll, tags, updateFilter }) => (
  <Container flex noPadding margin="20px" width="100%">
    <Container flex noPadding>
      <Text>
        <Text
          div
          small
          thin
          style={{
            width: '100px',
          }}
        >
          Select tags
          <br />
          for this note
        </Text>
        <Container noPadding>
          <Text smaller thinner primary a onClick={selectAll(true)}>
            All
          </Text>
          <Text
            smaller
            thinner
            style={{
              margin: '0 3px',
            }}
          >
            |
          </Text>
          <Text smaller thinner primary a onClick={selectAll(false)}>
            None
          </Text>
        </Container>
      </Text>
    </Container>
    <Container flex noPadding margin="0">
      <ul
        style={{
          margin: '0',
          padding: '0',
        }}
      >
        {tags.map((tag) => (
          <Tag
            id={tag.name}
            key={`tag-${Id}-${tag.name}`}
            active={tag.IsActive}
            updating={tag.IsUpdating}
          >
            <Text a light small={tag.IsActive} onClick={updateFilter(tag)}>
              {tag.name}
            </Text>
          </Tag>
        ))}
      </ul>
    </Container>
  </Container>
)

TagsEditor.displayName = 'TagsEditor'

TagsEditor.propTypes = {
  tags: PropTypes.array,
  updateFilter: PropTypes.func,
  selectAll: PropTypes.func,
  Id: PropTypes.string,
}

TagsEditor.defaultProps = {
  tags: [],
  updateFilter: null,
  selectAll: null,
  Id: '',
}

export default TagsEditor
